import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 댓글 삭제
 *
 * Origin: pageNicolasApi.removeComment
 * API: POST /api/v5/store/community/remove/comment
 */
export async function postStoreCommunityRemoveComment(
  commentUid: number,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/remove/comment',
    {
      method: 'POST',
      data: {commentUid},
    },
    options
  );
  return response.data;
}
